import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useParams } from 'react-router-dom';
import FormComponent from '../../../Reusable_Components/FormComponent';
import { API_ROUTES, API_DOMAIN, headers } from '../../../Reusable_Components/Config/apiConfig';

const SalesForecastInput = () => {
  const { forecastId = '' } = useParams();
  const decodedId = forecastId ? atob(forecastId) : forecastId;
  const id = decodedId.replace(/\D/g, '');
  const [isEditing, setIsEditing] = useState(false);
  const [formData, setFormData] = useState({});
  const route = 'salesForecast';

  useEffect(() => {
    if (forecastId) {
      setIsEditing(true);
      fetchForecastDetails();
    }
  }, [forecastId]); // eslint-disable-line react-hooks/exhaustive-deps

  const fetchForecastDetails = async () => {
    try {
      const response = await axios.get(`${API_DOMAIN}${API_ROUTES.salesForecast}${id}/`, { headers });
      const d = response.data;
      setFormData({
        ...d,
        customer: d.customer?.id ?? d.customer,
        created_by: d.created_by?.id ?? d.created_by,
      });
    } catch (error) {
      console.error('Error fetching sales forecast details:', error);
    }
  };

  const forecastFields = [
    {
      name: 'customer', label: 'Customer', type: 'async-select',
      endpoint: API_ROUTES.customer,
      getOptionLabel: (c) => c.name,
    },
    { name: 'forecast_date', label: 'Forecast Date', type: 'date' },
    {
      name: 'forecast_type', label: 'Forecast Type', type: 'select',
      options: [
        { value: 'pipeline', label: 'Pipeline' },
        { value: 'committed', label: 'Committed' },
        { value: 'best_case', label: 'Best Case' },
        { value: 'worst_case', label: 'Worst Case' },
        { value: 'actual', label: 'Actual' },
      ],
    },
    {
      name: 'period_type', label: 'Period Type', type: 'select',
      options: [
        { value: 'monthly', label: 'Monthly' },
        { value: 'quarterly', label: 'Quarterly' },
        { value: 'annual', label: 'Annual' },
        { value: 'custom', label: 'Custom' },
      ],
    },
    { name: 'forecast_amount', label: 'Forecast Amount', type: 'number' },
    { name: 'actual_amount', label: 'Actual Amount', type: 'number' },
    { name: 'confidence_level', label: 'Confidence Level (%)', type: 'number' },
    { name: 'notes', label: 'Notes', type: 'textarea' },
    {
      name: 'created_by', label: 'Created By', type: 'async-select',
      endpoint: API_ROUTES.users,
      getOptionLabel: (u) => u.username,
    },
  ];

  return (
    <div>
      <h1>{isEditing ? 'Edit Sales Forecast' : 'Create Sales Forecast'}</h1>
      <FormComponent fields={forecastFields} initialFormData={formData} route={route} cancelPath="/customer/sales-forecast/list" />
    </div>
  );
};

export default SalesForecastInput;
